<template>
  <div class="container mx-auto px-4">

    <h2>TFA Tester</h2>
    <label class="font-bold">Key</label>
    <input type="text" class="max-w-xs" v-model="state.key" @input="onKeyChange()" />
    <label class="font-bold">Base</label>
    <div class="flex items-center space-x-2">
      <input type="radio" id="radio-ascii" value="ascii" v-model="state.keyBase" @change="refresh()"/>
      <label for="radio-ascii" class="pr-4 py-1 rounded-md">ASCII</label>

      <input type="radio" id="radio-base10" value="10" v-model="state.keyBase" @change="refresh()"/>
      <label for="radio-base10" class="pr-4 py-1 rounded-md">Decimal</label>

      <input type="radio" id="radio-base16" value="16" v-model="state.keyBase" @change="refresh()"/>
      <label for="radio-base16" class="pr-4 py-1 rounded-md">Hex</label>

      <input type="radio" id="radio-base32" value="32" v-model="state.keyBase" @change="refresh()"/>
      <label for="radio-base32" class="pr-4 py-1 rounded-md">Base32</label>

      <input type="radio" id="radio-base64" value="64" v-model="state.keyBase" @change="refresh()"/>
      <label for="radio-base64" class="pr-4 py-1 rounded-md">Base64</label>
    </div>
    <div>Key in hex: {{ state.keyInHex }}</div>
    <div>Current Time: {{ state.currentTime }}</div>
    <div class="inline-block pr-4">Current Time Tag: {{ state.timeTag }}</div>
    <div class="inline-block pr-4">Time Left: {{ state.timeLeft }}</div>
    <div>Code: {{ state.code }}</div>

    <h2>Examples</h2>
    <TfaExample v-for="example in state.examples" 
      :tfaKey="example.key" 
      :keyBase="example.keyBase" 
      :time="example.time" 
      :interval="example.interval" 
      :expectedCode="example.expectedCode"
    />
  </div>
</template>

<script setup>
import Crypto from 'crypto-js'
import sha1 from 'crypto-js/sha1'
import aes from 'crypto-js/aes'
import {reactive} from 'vue'
import {getCode, BasedValue, guessBase} from '../../helpers/tfa.js'
import TfaExample from './TfaExample.vue'

let state = reactive({
  currentTime: Date.now(),
  timeTag: Math.floor(Date.now()/30000),
  timeLeft: 0,
  key: "12345678901234567890",
  keyBase: "ascii",
  code: "",
  examples: [{
    key: "12345678901234567890",
    keyBase: "ascii",
    time: new Date("1970-01-01T00:00:59Z"),
    interval: 30,
    expectedCode: "94287082"
  },{
    key: "12345678901234567890",
    keyBase: "ascii",
    time: new Date("2005-03-18T01:58:29Z"),
    interval: 30,
    expectedCode: "07081804"
  },{
    key: "12345678901234567890",
    keyBase: "ascii",
    time: new Date("2033-05-18T03:33:20Z"),
    interval: 30,
    expectedCode: "69279037"
  }]
})

function test() {
  let testDate = new Date("1970-01-01T00:00:59Z")
  state.testKey = "12345678901234567890"
  state.code1 = getCode(state.testKey, {time: testDate})
  state.good1 = "94287082"

  state.code2 = getCode(state.testKey, {time: new Date("2005-03-18T01:58:29Z"), interval: 30})
  state.good2 = "07081804"

  state.testDate3 = new Date("2033-05-18T03:33:20Z")
  state.key3 = "12345678901234567890"
  state.code3 = getCode(state.testKey, {time: state.testDate3, interval: 30})
  state.good3 = "69279037"
}



test()

refresh()
setInterval(() => {
  refresh()
}, 1000)

function refresh() {
  state.currentTime = new Date()
  state.timeTag = Math.floor(state.currentTime/30000)
  state.timeLeft = 30 - Math.floor((state.currentTime - state.timeTag * 30000 )/1000)
  if (state.keyBase === "ascii") {
    state.keyInHex = ""
    let value = state.key.split('').forEach((char) => {
      state.keyInHex += char.charCodeAt(0).toString(16)
    })
    state.code = getCode(state.key, {time: state.currentTime})
  } else {
    state.keyInHex = BasedValue(state.key, state.keyBase).toString(16)
    state.code = getCode(
      BasedValue(state.key, state.keyBase).toWords(),
      {time: state.currentTime}
    )
  }
}



function onKeyChange() {
  state.keyBase = guessBase(state.key) || state.keyBase
  refresh()
}


function encrypt(message, key) {
  return aes.encrypt(message, key).toString()
}

function decrypt(encrypted_message, key) {
  return aes.decrypt(encrypted_message, key).toString(Crypto.enc.Utf8)
}

window.encrypt = encrypt
window.decrypt = decrypt

window.BasedValue = BasedValue


window.sha1 = sha1
window.Crypto = Crypto
window.state = state
window.aes = aes
window.getCode = getCode

</script>